import { gql } from "@apollo/client/core";
import axios, { AxiosResponse } from "axios";
import { Publication } from "../../utils/hooks/types/publicationDataType";
import { TOKEN } from "../client";

export const DATE_RANGE_QUERY = gql`
query Deprecated ($params: GetTimeFrameParams) {
	Deprecated  {  
		getTimeFrame (params: $params) {
			publicationId
			timeFrame {
				begin
				end
			}
		}
	}
}
`;
/**
 *  Gets the publication information from the Foleon analytics
 */
export const PUBLICATION_QUERY = gql`
query Publication ($params: VisitorsOverTimeParams, $params1: PublicationParams) {
	Publication (params: $params1) {
		Sessions {
			avgPageviewsPerSessionCount
			avgSessionDuration
			sessionCount
		}
		Visitors {
			newVisitorCount
			visitorCount
		}
		
		VisitorsOverTime (params: $params) {
			visitorCount
			timestamp
			timeUnit
		}
	}
}
`;

/**
 *  Gets the publication id for every document in a project
 */
// eslint-disable-next-line max-len
export const getAllPublicationIds = (setRawPublications: any, setLoaded: any, projectId: number) => {
	// eslint-disable-next-line max-len
	axios.get(`https://api.acceptance.foleon.cloud/v2/magazine/edition?filter[0][field]=title&filter[0][value]=${projectId}&filter[0][type]=eq&filter[1][field]=status&filter[1][value]=published&filter[1][type]=eq`,
		{
			headers: {
				"Authorization": `Bearer ${TOKEN}`
			}
		})
		.then((result: AxiosResponse<any>) => {
			const rawPubs: Publication[] = [];
			const editions = result.data._embedded.edition;
			editions.forEach((doc: any) => {
				rawPubs.push({
					id: doc.id,
					name: doc.name,
					data: undefined
				});
			});
			setRawPublications(rawPubs);
			setLoaded(true);
		});
};
/**
 *  Gets the project title
 */
// eslint-disable-next-line max-len
export const getProjectTitle = (setProjectTitle: any, setProjectTitleLoaded: any, projectId: number) => {
	axios.get(`https://api.acceptance.foleon.cloud/v2/magazine/title/${projectId}`,
		{
			headers: {
				"Authorization": `Bearer ${TOKEN}`
			}
		})
		.then((result: AxiosResponse<any>) => {
			setProjectTitle(result.data.name);
			setProjectTitleLoaded(true);
		});
};